import { render, staticRenderFns } from "./Product_MakePrice.vue?vue&type=template&id=f8a2565a&scoped=true&"
import script from "./Product_MakePrice.vue?vue&type=script&lang=js&"
export * from "./Product_MakePrice.vue?vue&type=script&lang=js&"
import style0 from "./Product_MakePrice.vue?vue&type=style&index=0&id=f8a2565a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a2565a",
  null
  
)

export default component.exports